// src/App.js
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import AuthPage from './pages/AuthPage';
import DashboardPage from './pages/DashboardPage';
import { StoresPage, StoreFormPage } from './pages/StoresPage';
import ProductsPage from './pages/ProductsPage';
import CouponsPage from './pages/CouponsPage';
import AnalyticsPage from './pages/AnalyticsPage';
import ProfilePage from './pages/ProfilePage';
import './App.css';

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="app-loading"><div className="spinner" /></div>;
  return user ? children : <Navigate to="/auth" replace />;
};

const GuestOnly = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="app-loading"><div className="spinner" /></div>;
  return user ? <Navigate to="/" replace /> : children;
};

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/auth" element={<GuestOnly><AuthPage /></GuestOnly>} />
          <Route path="/" element={<Protected><DashboardPage /></Protected>} />
          <Route path="/stores" element={<Protected><StoresPage /></Protected>} />
          <Route path="/stores/new" element={<Protected><StoreFormPage /></Protected>} />
          <Route path="/stores/:id/edit" element={<Protected><StoreFormPage /></Protected>} />
          <Route path="/products" element={<Protected><ProductsPage /></Protected>} />
          <Route path="/coupons" element={<Protected><CouponsPage /></Protected>} />
          <Route path="/analytics" element={<Protected><AnalyticsPage /></Protected>} />
          <Route path="/profile" element={<Protected><ProfilePage /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
